module.exports = __webpack_public_path__ + "static/media/117.1d696110.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/117.jpg
// module id = 928
// module chunks = 0